<template>
    <span>
        <font-awesome-icon
            v-if="address.linkIgnore"
            icon="exclamation-triangle"
            class="mr-xs text-warning"
        />
        {{ address.full_address_with_apartment_number }}
        <span
            v-if="address.linkIgnore"
            class="inline-block text-neutral-darkest border-neutral-darkest bg-danger shadow-md mt-sm p-sm"
            style="background-color: #fae5e1; border-width: 1px;"
        >
            Link status ignored and MAC address not verified.
            The installation might not work or even exist at the intended customer.
            The following reason has been given:
            <span class="italic block m-sm">
                {{ address.linkIgnore.reason }}
            </span>
            <span class="font-bold text-right block">
                {{ address.linkIgnore.user_name }}
            </span>
            <span class="text-right block">
                {{ address.linkIgnore.date }}
            </span>
        </span>
    </span>
</template>
<script>
    export default {
        props: {
            initialAddress: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                address: this.initialAddress,
            };
        },
    };
</script>
